export function isBlockedByFraud (order) {
  if (!order) return false
  const fraudReview = order.fraudReview || {}
  if (fraudReview.status === 'fraud') return true
  if (fraudReview.activeCase && fraudReview.status !== 'dismissed') return true
  return false
}

export function fraudBlockMessage (order) {
  if (!order) return ''
  const fraudReview = order.fraudReview || {}
  const caseCode = fraudReview.activeCase
  const suffix = caseCode ? ` (${caseCode})` : ''
  return `Retenida por revisión de fraude${suffix}`
}

export function fraudCountTitle (count) {
  const n = Number(count) || 0
  if (n === 1) return '1 vez marcada como fraude'
  return `${n} veces marcada como fraude`
}



// WEBPACK FOOTER //
// ./src/helpers/fraudReview.js